import paths from '@app/src/wf-constants/paths'
import { LocalLibrary, LocalLibraryOutlined } from '@mui/icons-material'
import React from 'react'
import { useIntl } from 'react-intl'
import NavbarMenuItem from './LegacyNavbarMenuItem'

const YourDataMenuItem: React.FC = () => {
  const { formatMessage } = useIntl()

  return (
    <NavbarMenuItem
      path={paths.yourData}
      title={formatMessage({ id: 'navbar.yourData' })}
      icon={LocalLibraryOutlined}
      iconSelected={LocalLibrary}
    />
  )
}

export default YourDataMenuItem
